import React from 'react'
import { Link } from 'react-router-dom';

function Popup_content() {
  return (
    <div>
      {/* ----------------------mobile view--------------------- */}
      {/* <div className='container  d-lg-none d-md-block'>
        <h1 className='display-5 pt-4 text-center'>Join Our Community</h1>
        <div className='row pt-2'>
            <div className='col-md-6'>
                <div className='mobile_pop_up_text'>
                <h5 className='text-center'>Become InternsElite’s Campus Ambassador</h5>
                <p className='px-2 pt-3 text-center'>
                You will act as the face of InternsElite on your university's campus and represent our company there. In this position, you will play a crucial role in managing InternsElite's Career-defining programs for underprepared college students who are looking to build a more impressive resume.
                An interesting opportunity to gain exposure in the corporate world and generate revenue while you read! And the average time investment is less than 2 hours per week.
                </p>
                </div>
                <div className='text-center'>
                 <Link to="/CA"><button className="text-white shadow-sm fs-6 px-4 pt-1 pb-2 Navbar_button">View More</button></Link>
                </div>
            </div>
            <div className='col-md-6 border-top '>
                <div className='mobile_pop_up_text pt-3'>
                <h5 className='text-center'>Looking For A Job?</h5>
                <p className='px-2 pt-3 text-center'>At InternsElite, you'll have the opportunity to grow professionally, personally, and environmentally while still earning a competitive salary.Please fill out the form and attach your CV/portfolio; we will get in touch with you as soon as possible. 
                </p>
                </div>
                <div className='text-center'>
                 <Link to="/BDA"><button className="text-white shadow-sm fs-6 px-4 pt-1 pb-2 Navbar_button">View More</button></Link>
                </div>
            </div>
        </div>
      </div> */}


      {/* ----------------------desktop view--------------------- */}
      <div className='container pb-4 d-none d-lg-block'>
        <h1 className='display-5 text-center text-dark'>Join Our Community</h1>
        <div className='row pt-4'>
            <div className='col-md-6'>
                <div className='pop_up_text'>
                <h5 className='text-center'>Become InternsElite’s Campus Ambassador</h5>
                <p className='px-5 pt-3 pb-2'>
                You will act as the face of InternsElite on your university's campus and represent our company there. In this position, you will play a crucial role in managing InternsElite's Career-defining programs for underprepared college students who are looking to build a more impressive resume.<br></br>
                An interesting opportunity to gain exposure in the corporate world and generate revenue while you read! And the average time investment is less than 2 hours per week.
                </p>
                </div>
                <div className='px-5 text-center'>
                 <Link to="/CA"><button className="text-white shadow-sm fs-6 px-5 py-2 Navbar_button">View More</button></Link>
                </div>
            </div>
            <div className='col-md-6 border-start border-dark'>
                <div className='pop_up_text'>
                <h5 className='text-center'>Looking For A Job?</h5>
                <p className='px-5 py-4'>At InternsElite, you'll have the opportunity to grow professionally, personally, and environmentally while still earning a competitive salary.<br></br>Please fill out the form and attach your CV/portfolio; we will get in touch with you as soon as possible. 
                </p>
                </div>
                <div className='px-5 pt-1 text-center'>
                <Link to="/BDA"><button  className="text-white shadow-sm fs-6 px-5 py-2 Navbar_button">View More</button></Link>
                </div>
            </div>
        </div>
      </div>
    </div>
  )
}

export default Popup_content
